import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { DeformableTransform } from '~/domain/dvf/deformableTransform';
import {
    DeformableRegistration,
    isDeformableRegistration,
} from '~/domain/patient/deformableRegistration';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import { toDeformableTransform } from '~/hooks/workflows/dvf/deformableRegistrationField';
import { replanningRunRegistrationsState } from '~/state/atoms/adaptiveReplanningAtoms';

export interface RunDeformation {
    readonly registration: DeformableRegistration;
    readonly transform: DeformableTransform;
}

// The deformation this run produced, whatever registration is on screen.
export function useRunDeformation(): RunDeformation | undefined {
    const patient = useSelectedPatient();
    const runRegistrations = useRecoilValue(replanningRunRegistrationsState);
    return useMemo(() => {
        const registration = runRegistrations
            .map((uid) => patient?.getRegistrationWithSopInstanceUid(uid))
            .find(
                (candidate): candidate is DeformableRegistration =>
                    !!candidate && isDeformableRegistration(candidate)
            );
        const transform = toDeformableTransform(registration);
        return registration && transform
            ? { registration, transform }
            : undefined;
    }, [patient, runRegistrations]);
}
